import { getCookie } from '../helpers/cookies';
const setFieldValue = (fieldName, value) => {
    if (value === null || value.trim() === '') {
        return;
    }
    const field = document.querySelector(`input[name="${fieldName}"]`);
    if (field) {
        try {
            field.value = decodeURIComponent(value.replace(/\+/g, ' '));
        }
        catch (error) {
            console.error(`Error decoding URI component: ${error}`);
        }
    }
};
const prefillFormFields = () => {
    const urlParams = new URLSearchParams(window.location.search);
    setFieldValue('username', getCookie('username'));
    setFieldValue('account_name', urlParams.get('companyname'));
    setFieldValue('first_name', urlParams.get('firstname'));
    setFieldValue('last_name', urlParams.get('lastname'));
    setFieldValue('username', urlParams.get('username'));
    setFieldValue('email1', urlParams.get('email'));
    setFieldValue('email', urlParams.get('email'));
    setFieldValue('phone_number_c', urlParams.get('phone'));
    setFieldValue('mobile_number_c', urlParams.get('mobilenumber'));
    setFieldValue('website', urlParams.get('website'));
    setFieldValue('sugar_lead_id', urlParams.get('sugarleadid'));
    setFieldValue('voucher_code_c', urlParams.get('voucher_code'));
    const usernameParam = urlParams.get('username');
    if (usernameParam) {
        submitForm();
    }
};
const submitForm = () => {
    const form = document.querySelector('.customer-referral-form form');
    if (form) {
        const event = new Event('submit', {
            bubbles: true,
            cancelable: true,
        });
        form.dispatchEvent(event);
    }
};
export const initPrefill = () => {
    document.readyState === 'loading'
        ? document.addEventListener('DOMContentLoaded', prefillFormFields)
        : prefillFormFields();
};
